import { useEffect } from "react";

const ScrollLock = ({ isActive }) => {
  useEffect(() => {
    if (isActive) {
      const originalStyle = window.getComputedStyle(document.body).overflow;
      document.body.style.overflow = "hidden";
      return () => {
        document.body.style.overflow = originalStyle;
      };
    }
  }, [isActive]);

  return null;
};

export const TouchScrollable = ({ children }) => {
  return children;
};

export default ScrollLock;
